import { krakenApi, poirotApi } from "../config/http-common";
import countryData from "../types/country.type";
import personData from "../types/person.type";
import documentTypeData from "../types/documentType.type";

class CountryDataService {
  getAll() {
    return krakenApi.get<Array<countryData>>("/enrollment/countries");
  }
  get(ci: string, documentType: string) {
    return poirotApi.get<personData>(`/external/${documentType}/${ci}`);
  }
  getDocumentType(id: string) {
    return krakenApi.get<documentTypeData>(`/enrollment/documentTypes?countryId=${id}`);
  }
}

export default new CountryDataService();